import type { FC } from 'react';
import type { SelectValuesFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { Stack } from '@packages/shared';
import { DialogVariationSelectionRow } from '../DialogVariationSelectionRow';

export type DialogVariationSelectionProps = {
  /**
   * The GraphQL values data for the given product
   */
  valuesData: SelectValuesFragmentFragment['values'];
  /**
   * callback handler for closing the dialog on click
   */
  handleClose(): void;
  onChange?: (sku: string) => void;
};

/**
 * DialogVariationSelection component
 *
 * used to display the selected dimension
 * opens dialog on click to select a different variation
 *
 * */
export const DialogVariationSelection: FC<DialogVariationSelectionProps> = ({
  valuesData,
  handleClose,
  onChange,
}) => {
  // const router = useRouter();
  const hasImage = valuesData.some(
    (value) => value.image !== null || value.rgb !== null || value.variationMainImage !== null,
  );

  const clickHandler = (sku: SelectValuesFragmentFragment['values'][number]['sku']) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    onChange && sku && onChange(sku);
    handleClose();
    // navigateToSKU(sku, router);
  };

  return (
    <Stack>
      {valuesData.map((value) => (
        <DialogVariationSelectionRow
          value={value}
          hasImage={hasImage}
          clickHandler={clickHandler}
          key={value.sku}
        />
      ))}
    </Stack>
  );
};
